import {Component} from "@angular/core";
import {Client} from "src/app/services/API/client";
import {DynamicFieldService} from "src/app/services/ux/dynamic-field-service";
import {FormGroup} from "@angular/forms";
import {toastrService} from "src/app/services/ux/toastr.service";
import {ModalPaymentService} from "src/app/services/ux/modal-payment.service";

@Component({
    templateUrl: "modal-add-contract-content.component.html",
    selector: "app-modal-add-contract-content"
})
export class AddContractComponent {
    defaultFields: any = [
        {label: "Pershkrimi", searchLabel: "ContractName", type: "text"}
    ];

    selectedService: any;
    fields: any;
    form: FormGroup;

    selectedContract: any;
    isEditingContract = false;

    DEFAULT_FIELD_NAME = "ContractNumber";

    constructor(
        private client: Client,
        private dfs: DynamicFieldService,
        private toastr: toastrService,
        private modalService: ModalPaymentService
    ) {
    }

    selectService(service: any) {
        this.selectedService = service;
        this.getServiceFields();
    }

    updateContract(contract: any) {
        this.selectedContract = contract;
        this.isEditingContract = true;
    }

    getServiceFields(): void {
        this.client
            .get(`api/services/${this.selectedService.id}/fields`)
            .then((res: any) => {
                const toFind = res.findIndex((q) => q.position === 1);

                if (this.selectedService.code === "OSHEE") {
                    if (toFind === -1) {
                        return this.toastr.warning("Ju lutem provoni me vone!");
                    }
                    res[toFind].searchLabel = this.DEFAULT_FIELD_NAME;

                    const invoiceType = res.findIndex(
                        (q) => q.searchLabel === "isAktMarreveshje"
                    );
                    if (invoiceType !== -1) {
                        res[invoiceType].searchLabel = "InvoiceType";
                    }
                }

                if (this.selectedService.code === "DOGANA") {
                    const barcodeField = res.findIndex((q) => q.searchLabel === "barcode");
                    if (barcodeField !== -1) {
                        res[barcodeField].searchLabel = "PackageCode";
                    }
                }

                if (this.selectedService.code === "TATIME") {
                    const barcodeField = res.findIndex(
                        (q) => q.searchLabel === "serialNumber"
                    );
                    if (barcodeField !== -1) {
                        res[barcodeField].searchLabel = "serialNumber";
                    }
                }

                if (this.selectedService.code === "UKT") {
                    const cityField = res.findIndex(
                        (q) => q.searchLabel === "institutionCode"
                    );
                    if (cityField !== -1) {
                        res[cityField].searchLabel = "CityName";
                    }
                }

                if (this.selectedService.code === "ONE") {
                    const mobileNumberField = res.findIndex(
                        (q) => q.searchLabel === "mobileNumber"
                    );
                    if (mobileNumberField !== -1) {
                        res[mobileNumberField].searchLabel = "msisdn";
                    }
                }

                if (this.selectedService.code === "ALBTELECOM") {
                    const mobileNumberField = res.findIndex(
                        (q) => q.searchLabel === "mobileNumber"
                    );
                    if (mobileNumberField !== -1) {
                        res[mobileNumberField].searchLabel = "msisdn";
                    }
                }

                if (this.selectedService.code === "KINDERGARDEN") {
                    res.push({
                        type: "kindergarden-dropdown",
                        label: "Lloji",
                        searchLabel: "serviceid",
                        value: -1,
                        position: 99
                    });
                }

                if (this.selectedService.code === "ALBTELECOMCONTRACT") {
                    res.push({
                        type: "albtelecom-contract-dropdown",
                        label: "Lloji",
                        searchLabel: "SearchType",
                        value: -1,
                        position: 99
                    });
                }

                this.fields = res;

                this.fields.push({
                    label: "fieldCode",
                    searchLabel: "FieldCode",
                    type: "hidden",
                    value: this.fields[toFind].fieldName
                });
                this.fields = [...this.defaultFields, ...res];

                if (
                    this.isEditingContract &&
                    typeof this.selectedContract !== "undefined"
                ) {
                    this.addFormValuesFromContract(true);
                }

                this.form = this.dfs.toFormGroup(this.fields);
                this.modalService.open();
            });
    }

    onSave() {
        const requestObject = this.form.value;

        if (typeof requestObject.InvoiceType !== "undefined") {
            requestObject.InvoiceType = requestObject.InvoiceType ? "A" : "F";
        }

        if (this.isEditingContract) {
            this.client
                .put(
                    `api/${this.selectedService.code.toLowerCase()}/${
                        this.selectedContract.contractId
                    }`,
                    requestObject
                )
                .then(() => {
                    this.modalService.close();
                    this.toastr.success("Kontrata u ndryshua me sukses!");
                    this.addFormValuesFromContract();
                });
        } else {
            this.client
                .post("api/" + this.selectedService.code.toLowerCase(), this.form.value)
                .then((res: any) => {
                    if (res.contractId) {
                        this.toastr.success("Kontrata juaj u ruajt me sukses");
                    } else {
                        this.toastr.warning(res);
                    }
                    this.modalService.close();
                })
                .catch((err) => {
                    if (err.error === "invalid_parameters") {
                        this.toastr.error("Plotesoni fushat");
                    } else if (err.error === "contract_exist") {
                        this.toastr.error("Kjo kontrate eshte e regjistruar");
                    } else {
                        this.toastr.error(err.error);
                    }
                });
        }
    }

    addFormValuesFromContract(isContact = false) {
        switch (this.selectedService.code) {
            case "OSHEE":
                this.updateOshee(isContact);
                break;
            case "GJOBA":
                this.updateGjoba(isContact);
                break;
            case "DOGANA":
                this.updateDogana(isContact);
                break;
            case "UKT":
                this.updateUk(isContact);
                break;
            case "ZRPP":
                this.updateZrpp(isContact);
                break;
            case "TATIME":
                this.updateTatime(isContact);
                break;
            case "ALBTELECOM":
                this.updateAlbtelecom(isContact);
                break;
            case "ONE":
                this.updateOne(isContact);
                break;
            case "KINDERGARDEN":
                this.updateKindergarden(isContact);
                break;
            case "ALBTELECOMCONTRACT":
                this.updateAlbtelecomContract(isContact);
                break;
        }
    }

    updateOshee(isContact) {
        const contractName = this.fields.findIndex(
            (q) => q.searchLabel === "ContractName"
        );
        const customerNumber = this.fields.findIndex((q) => q.position === 1);
        const invoiceNumber = this.fields.findIndex((q) => q.position === 2);
        const isAktMarreveshje = this.fields.findIndex((q) => q.position === 3);

        if (isContact) {
            this.fields[customerNumber].value = this.selectedContract.customerNumber;
            // this.fields[invoiceNumber] = customerNumber;
            this.fields[
                isAktMarreveshje
                ].value = this.selectedContract.isAktMarreveshje;
            this.fields[contractName].value = this.selectedContract.contractName;
        } else {
            this.selectedContract.customerNumber = this.form.value.ContractNumber;
            // this.fields[invoiceNumber] = customerNumber;
            this.selectedContract.isAktMarreveshje =
                this.form.value.InvoiceType == "F" ? false : true;
            this.selectedContract.contractName = this.form.value.ContractName;
        }
    }

    updateGjoba(isContact) {
        const contractName = this.fields.findIndex(
            (q) => q.searchLabel === "ContractName"
        );
        const plate = this.fields.findIndex((q) => q.position === 1);

        if (isContact) {
            this.fields[contractName].value = this.selectedContract.contractName;
            this.fields[plate].value = this.selectedContract.plate;
        } else {
            this.selectedContract.contractName = this.form.value.ContractName;
            this.selectedContract.plate = this.form.value.plate;
        }
    }

    updateZrpp(isContact) {
        const contractName = this.fields.findIndex(
            (q) => q.searchLabel === "ContractName"
        );
        const invoiceCode = this.fields.findIndex((q) => q.position === 1);

        if (isContact) {
            this.fields[contractName].value = this.selectedContract.contractName;
            this.fields[invoiceCode].value = this.selectedContract.invoiceCode;
        } else {
            this.selectedContract.contractName = this.form.value.ContractName;
            this.selectedContract.invoiceCode = this.form.value.invoiceCode;
        }
    }

    updateDogana(isContact) {
        const contractName = this.fields.findIndex(
            (q) => q.searchLabel === "ContractName"
        );
        const barcode = this.fields.findIndex((q) => q.position === 1);

        if (isContact) {
            this.fields[contractName].value = this.selectedContract.contractName;
            this.fields[barcode].value = this.selectedContract.barcode;
        } else {
            this.selectedContract.contractName = this.form.value.ContractName;
            this.selectedContract.barcode = this.form.value.PackageCode;
        }
    }

    updateTatime(isContact) {
        const contractName = this.fields.findIndex(
            (q) => q.searchLabel === "ContractName"
        );
        const serialNumber = this.fields.findIndex((q) => q.position === 1);

        if (isContact) {
            this.fields[contractName].value = this.selectedContract.contractName;
            this.fields[serialNumber].value = this.selectedContract.serialNumber;
        } else {
            this.selectedContract.contractName = this.form.value.ContractName;
            this.selectedContract.serialNumber = this.form.value.serialNumber;
        }
    }

    updateUk(isContact) {
        const contractName = this.fields.findIndex(
            (q) => q.searchLabel === "ContractName"
        );
        const contractNumber = this.fields.findIndex((q) => q.position === 1);
        const institutionCode = this.fields.findIndex((q) => q.position === 2);

        if (isContact) {
            this.fields[contractName].value = this.selectedContract.contractName;
            this.fields[contractNumber].value = this.selectedContract.contractNumber;
            this.fields[institutionCode].value = this.selectedContract.institutionCode;
        } else {
            this.selectedContract.contractName = this.form.value.ContractName;
            this.selectedContract.contractNumber = this.form.value.contractNumber;
            this.selectedContract.institutionCode = this.form.value.CityName;
        }
    }

    updateAlbtelecom(isContact) {
        const contractName = this.fields.findIndex(
            (q) => q.searchLabel === "ContractName"
        );
        const mobileNumber = this.fields.findIndex((q) => q.position === 1);

        if (isContact) {
            this.fields[contractName].value = this.selectedContract.contractName;
            this.fields[mobileNumber].value = this.selectedContract.mobileNumber;
        } else {
            this.selectedContract.contractName = this.form.value.ContractName;
            this.selectedContract.serialNumber = this.form.value.mobileNumber;
        }
    }

    updateOne(isContact) {
        const contractName = this.fields.findIndex(
            (q) => q.searchLabel === "ContractName"
        );
        const mobileNumber = this.fields.findIndex((q) => q.position === 1);

        if (isContact) {
            this.fields[contractName].value = this.selectedContract.contractName;
            this.fields[mobileNumber].value = this.selectedContract.mobileNumber;
        } else {
            this.selectedContract.contractName = this.form.value.ContractName;
            this.selectedContract.serialNumber = this.form.value.mobileNumber;
        }
    }

    updateKindergarden(isContact) {
        const contractName = this.fields.findIndex(
            (q) => q.searchLabel === "ContractName"
        );
        const emri = this.fields.findIndex((q) => q.position === 1);
        const mbiemri = this.fields.findIndex((q) => q.position === 2);
        // * AKA: Tipi i sherbimit, Kopesht/Cerdhe
        const serviceid = this.fields.findIndex((q) => q.position === 99);

        if (isContact) {
            this.fields[contractName].value = this.selectedContract.contractName;
            this.fields[emri].value = this.selectedContract.firstName;
            this.fields[mbiemri].value = this.selectedContract.lastName;
            this.fields[serviceid].value = this.selectedContract.serviceid;
        } else {
            this.selectedContract.contractName = this.form.value.ContractName;
            this.selectedContract.firstName = this.form.value.firstName;
            this.selectedContract.lastName = this.form.value.lastName;
            this.selectedContract.serviceid = this.form.value.serviceid;
        }
    }

    updateAlbtelecomContract(isContact) {
        const contractName = this.fields.findIndex(
            (q) => q.searchLabel === "ContractName"
        );
        const number = this.fields.findIndex((q) => q.position === 1);
        // * AKA: Tipi i fatures, Serial/Kontrat
        const searchType = this.fields.findIndex((q) => q.position === 99);

        if (isContact) {
            this.fields[contractName].value = this.selectedContract.contractName;
            this.fields[number].value = this.selectedContract.number;
            this.fields[searchType].value = this.selectedContract.searchType;
        } else {
            this.selectedContract.contractName = this.form.value.ContractName;
            this.selectedContract.number = this.form.value.number;
            this.selectedContract.searchType = this.form.value.SearchType;
        }
    }
}
